import React from 'react';
import { motion } from 'framer-motion';
import '../style.css';
import '../nov.css';

const PartnersMarquee = () => {
  const platforms = [
    {
      name: "Spotify",
      description: "The world's largest music streaming platform.",
      color: "rgb(29, 185, 84)",
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 496 512" className="text-3xl" height="1em" width="1em">
          <path d="M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"></path>
        </svg>
      )
    },
    {
      name: "Apple Music",
      description: "Apple's premium music streaming service.",
      color: "rgb(255, 78, 107)",
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" role="img" viewBox="0 0 24 24" className="text-3xl" height="1em" width="1em">
          <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 00-1.877-.726 10.496 10.496 0 00-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026-.747.043-1.49.123-2.193.4-1.336.53-2.3 1.452-2.865 2.78-.192.448-.292.925-.363 1.408-.056.392-.088.785-.1 1.18 0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424.05.815.154 1.624.497 2.373.65 1.42 1.738 2.353 3.234 2.801.42.127.856.187 1.293.228.555.053 1.11.06 1.667.06h11.03a12.5 12.5 0 001.57-.1c.822-.106 1.596-.35 2.295-.81a5.046 5.046 0 001.88-2.207c.186-.42.293-.87.37-1.324.113-.675.138-1.358.137-2.04-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206-.29.59-.76.962-1.388 1.14-.35.1-.706.157-1.07.173-.95.045-1.773-.6-1.943-1.536a1.88 1.88 0 011.038-2.022c.323-.16.67-.25 1.018-.324.378-.082.758-.153 1.134-.24.274-.063.457-.23.51-.516a.904.904 0 00.02-.193c0-1.815 0-3.63-.002-5.443a.725.725 0 00-.026-.185c-.04-.15-.15-.243-.304-.234-.16.01-.318.035-.475.066-.76.15-1.52.303-2.28.456l-2.325.47-1.374.278c-.016.003-.032.01-.048.013-.277.077-.377.203-.39.49-.002.042 0 .086 0 .13-.002 2.602 0 5.204-.003 7.805 0 .42-.047.836-.215 1.227-.278.64-.77 1.04-1.434 1.233-.35.1-.71.16-1.075.172-.96.036-1.755-.6-1.92-1.544-.14-.812.23-1.685 1.154-2.075.357-.15.73-.232 1.108-.31.287-.06.575-.116.86-.177.383-.083.583-.323.6-.714v-.15c0-2.96 0-5.922.002-8.882 0-.123.013-.25.042-.37.07-.285.273-.448.546-.518.255-.066.515-.112.774-.165.733-.15 1.466-.296 2.2-.444l2.27-.46c.67-.134 1.34-.27 2.01-.403.22-.043.442-.088.663-.106.31-.025.523.17.554.482.008.073.012.148.012.223.002 1.91.002 3.822 0 5.732z"></path>
        </svg>
      )
    },
    {
      name: "Amazon Music",
      description: "Amazon's comprehensive music platform.",
      color: "rgb(0, 168, 225)",
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" className="text-3xl" height="1em" width="1em">
          <path d="M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"></path>
        </svg>
      )
    },
    {
      name: "YouTube Music",
      description: "Google's music streaming and discovery platform.",
      color: "rgb(255, 0, 0)",
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 576 512" className="text-3xl" height="1em" width="1em">
          <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path>
        </svg>
      )
    },
    {
      name: "Deezer",
      description: "A music streaming platform with an extensive music catalog.",
      color: "rgb(162, 56, 255)",
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 576 512" className="text-3xl" height="1em" width="1em">
          <path d="M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"></path>
        </svg>
      )
    },
    {
      name: "Tidal",
      description: "A music streaming service offering high-quality audio and exclusive content.",
      color: "rgb(0, 0, 0)",
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" role="img" viewBox="0 0 24 24" className="text-3xl" height="1em" width="1em">
          <path d="M12.012 3.992L8.008 7.996 4.004 3.992 0 7.996 4.004 12l4.004-4.004L12.012 12l-4.004 4.004 4.004 4.004 4.004-4.004L12.012 12l4.004-4.004-4.004-4.004zM16.042 7.996l3.979-3.979L24 7.996l-3.979 3.979z"></path>
        </svg>
      )
    }
  ];

  return (
    <section id="partners-marquee" className="bg-white py-12 lg:py-20 relative overflow-hidden" style={{ fontFamily: 'aesthet-nova, Helvetica, Arial' }}>
      <div className="container mx-auto px-4 lg:px-0 relative z-10">
        <div className="w-full flex flex-col items-center justify-center my-12">
          
          {/* Header */}
          <div className="w-full text-center mb-16">
            <motion.div 
              className="mb-8 mt-4 text-center"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <span className="text-sm font-medium badge-gradient text-gray-700 py-3 px-6 rounded-full inline-block uppercase tracking-wide" style={{ fontFamily: 'aesthet-nova' }}>
                Powerful Partnerships, Powerful Distribution
              </span>
            </motion.div>
            
            <motion.h2 
              className="text-3xl md:text-5xl lg:text-6xl font-bold mb-8 relative" 
              style={{ fontFamily: 'aesthet-nova', fontWeight: 700 }}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="flex items-center justify-center gap-3">
                <motion.span 
                  style={{ color: 'rgb(70, 52, 135)' }}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                >
                  REACH THE
                </motion.span>
                <motion.span 
                  style={{ '--shimmer-width': '250px' }} 
                  className="text-neutral-600/50 animate-shimmer bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shimmer-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite] bg-gradient-to-r from-neutral-100 via-black/80 via-50% to-neutral-100"
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                >
                  BIGGEST PLATFORMS
                </motion.span>
              </div>
            </motion.h2>
            
            <motion.p 
              className="px-4 md:text-xl font-light max-w-[577px] m-auto text-black leading-relaxed" 
              style={{ fontFamily: 'system-ui, Avenir, Helvetica, Arial, sans-serif' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              Media Nov collaborates with industry-leading platforms to bring your music to the widest audience.
            </motion.p>
          </div>

          {/* Marquee - Double Row */}
          <div className="space-y-6 py-8">
            {/* First Row - Left to Right */}
            <div className="marquee-wrapper relative w-full overflow-hidden">
              <div className="marquee flex gap-6">
                {[...Array(3)].map((_, copyIndex) => (
                  <div key={copyIndex} className="marquee-content flex animate-marquee gap-6">
                    {platforms.slice(0, 3).map((platform, index) => (
                      <motion.div 
                        key={`${copyIndex}-${index}`} 
                        className="group relative flex flex-row items-center justify-start rounded-2xl px-3 py-2 text-xs font-medium shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm bg-white w-[240px] h-[70px] flex-shrink-0"
                        whileHover={{ 
                          y: -8,
                          scale: 1.05,
                          transition: { duration: 0.3, type: "spring", stiffness: 300 }
                        }}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ delay: index * 0.1 }}
                      >
                        <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                        <div className="flex h-full w-full px-2 py-1 rounded-xl items-center gap-2">
                          <motion.div 
                            className="flex-shrink-0" 
                            style={{ color: platform.color }}
                            whileHover={{ rotate: 360, scale: 1.2 }}
                            transition={{ duration: 0.5 }}
                          >
                            {platform.icon}
                          </motion.div>
                          <div className="flex-1">
                            <motion.h3 
                              className="text-sm font-bold text-black"
                              initial={{ opacity: 0, x: -10 }}
                              whileInView={{ opacity: 1, x: 0 }}
                              viewport={{ once: true }}
                              transition={{ delay: index * 0.1 + 0.2 }}
                            >
                              {platform.name}
                            </motion.h3>
                            <motion.p 
                              className="text-[10px] text-gray-600 mt-1 leading-tight"
                              initial={{ opacity: 0, x: -10 }}
                              whileInView={{ opacity: 1, x: 0 }}
                              viewport={{ once: true }}
                              transition={{ delay: index * 0.1 + 0.3 }}
                            >
                              {platform.description}
                            </motion.p>
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            {/* Second Row - Right to Left */}
            <div className="marquee-wrapper relative w-full overflow-hidden">
              <div className="marquee flex gap-6">
                {[...Array(3)].map((_, copyIndex) => (
                  <div key={copyIndex} className="marquee-content flex animate-marquee-reverse gap-6">
                    {platforms.slice(3, 6).map((platform, index) => (
                      <motion.div 
                        key={`${copyIndex}-${index}`} 
                        className="group relative flex flex-row items-center justify-start rounded-2xl px-3 py-2 text-xs font-medium shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm bg-white w-[240px] h-[70px] flex-shrink-0"
                        whileHover={{ 
                          y: -8,
                          scale: 1.05,
                          transition: { duration: 0.3, type: "spring", stiffness: 300 }
                        }}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ delay: index * 0.1 }}
                      >
                        <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                        <div className="flex h-full w-full px-2 py-1 rounded-xl items-center gap-2">
                          <motion.div 
                            className="flex-shrink-0" 
                            style={{ color: platform.color }}
                            whileHover={{ rotate: 360, scale: 1.2 }}
                            transition={{ duration: 0.5 }}
                          >
                            {platform.icon}
                          </motion.div>
                          <div className="flex-1">
                            <motion.h3 
                              className="text-sm font-bold text-black"
                              initial={{ opacity: 0, x: -10 }}
                              whileInView={{ opacity: 1, x: 0 }}
                              viewport={{ once: true }}
                              transition={{ delay: index * 0.1 + 0.2 }}
                            >
                              {platform.name}
                            </motion.h3>
                            <motion.p 
                              className="text-[10px] text-gray-600 mt-1 leading-tight"
                              initial={{ opacity: 0, x: -10 }}
                              whileInView={{ opacity: 1, x: 0 }}
                              viewport={{ once: true }}
                              transition={{ delay: index * 0.1 + 0.3 }}
                            >
                              {platform.description}
                            </motion.p>
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Button */}
          <motion.div 
            className="text-center mt-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ delay: 0.5 }}
          >
            <motion.a 
              href="#" 
              className="inline-flex items-center justify-center px-8 py-4 font-medium rounded-full transition-all duration-500 button-shimmer-white"
              whileHover={{ scale: 1.1, y: -4 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              Discover All Platforms
            </motion.a>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default PartnersMarquee;
